const dotpath = require('@ua/dotpathlookup')

const getContext = require('airship/modules/page-context')
const waffle = require('airship/modules/waffle')

const notifyModal = require('airship/widgets/notify-modal')

const context = getContext()
const el = document.querySelector('[rel=notify]')

const isEcommerce = dotpath('context_processors.current_company.is_ecommerce')(
  context
)

init()

function init() {
  if (!waffle.flag_is_active('web_notify_dogfooding')) {
    return
  }

  if (el && isEcommerce) {
    notifyModal(el)
  }

  if (!isEcommerce) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (let registration of registrations) {
        registration.unregister()
      }
    })
  }
}
